import React from 'react';
import { motion } from 'framer-motion';
import styles from './ReportesPage.module.css';
import { FinancialReportCard } from './components/FinancialReportCard';
import { KardexReportCard } from './components/KardexReportCard';
import { BarChart3 } from 'lucide-react';

export const ReportesPage: React.FC = () => {

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
            }
        }
    };

    return (
        <div className={styles.reportesPageContainer}>
            <header className={styles.header}>
                <BarChart3 size={32} className={styles.headerIcon} />
                <div>
                    <h1 className={styles.title}>Central de Reportes</h1>
                    <p className={styles.subtitle}>Genere y descargue informes detallados sobre la actividad de su despacho.</p>
                </div>
            </header>

            <motion.main 
                className={styles.gridContainer}
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <FinancialReportCard />
                <KardexReportCard />
            </motion.main>
        </div>
    );
};